<template>
  <span>
    <b-row class="row-padding title">Atenção!</b-row>
    <b-row class="row-padding">
      A Zucchetti está acompanhando de perto os movimentos da Reforma Tributária e com o objetivo de
      tornar esse processo de transição mais simples e claro para você, adicionamos abaixo campos
      que simulam a nova tributação que entrará em vigor com a Reforma tributária. Os campos
      apresentados são apenas para exemplos e poderão sofrer alterações conforme novas definições
      legais.
    </b-row>
  </span>
</template>

<script>
export default { name: 'IBSRegimeFormMessage' };
</script>

<style scoped>
.title {
  font-size: large;
  font-weight: bold;
}
.row-padding {
  padding: 0rem 2rem 1rem 2rem;
}
</style>
